import React from 'react';
import { ImagePlaceholder } from '@navi-toolbox/ui-components';
import { Breakpoint } from 'types/utils';
import { jcm } from 'utils';
import { PictureSources } from '../photos-modal.types';
import { Styles as StylesAtTouch } from './modal-layout-touch.styles';
import { useTranslation } from 'react-i18next';

export const PictureThumbAtTouch: React.FC<{
  isActive: boolean;
  thumbPicture: PictureSources;
  activeThumbRef: React.RefObject<HTMLButtonElement>;
  breakpoint: Breakpoint;
  setShowedPicture?: (value: PictureSources) => void;
}> = ({ isActive, thumbPicture, activeThumbRef, breakpoint, setShowedPicture }) => {
  const { t } = useTranslation();
  const onClickCb = React.useCallback(() => {
    setShowedPicture?.(thumbPicture);
  }, [setShowedPicture, thumbPicture]);

  return (
    <button
      className={jcm({
        [StylesAtTouch.thumb]: true,
        [StylesAtTouch.thumbMobile]: breakpoint === 'mobile',
        [StylesAtTouch.thumbActive]: isActive,
      })}
      onClick={onClickCb}
      ref={isActive ? activeThumbRef : undefined}
      role="tab"
      aria-selected={isActive}
    >
      <ImagePlaceholder
        className={jcm({
          [StylesAtTouch.thumbImg]: true,
          [StylesAtTouch.thumbImgMobile]: breakpoint === 'mobile',
        })}
        src={thumbPicture.urlThumb}
        loading="lazy"
        alt=""
        fallbackAlt={t('ui.image.alt')}
        fallbackWidth={48}
        fallbackHeight={48}
      />
    </button>
  );
};
